import React, { useState } from "react";
import "./accordion.css";
import upArrow from "../../../assets/icons/accordion-up.svg";
import downArrow from "../../../assets/icons/accordion-down.svg";

const Accordion = (props) => {
  const { data } = props;

  const [isActive, setIsActive] = useState(false);

  return (
    <div className=" accordion-main-container my-3 w-100 py-2 px-4 fn_Nunito cursor_pointer">
      <div
        className="d-flex justify-content-between align-items-center my-1"
        onClick={() => setIsActive(!isActive)}
      >
        <div className="fs_16 fs_sm_14">{data.question}</div>
        <div className="">
          {isActive ? (
            <img src={upArrow} width="16px" height="16px" />
          ) : (
            <img src={downArrow} width="16px" height="16px" />
          )}
        </div>
      </div>
      {isActive && (
        <p
          className="accordion-content color_747f9e fs_14 fs_sm_12"
          dangerouslySetInnerHTML={{ __html: data.answer }}
        ></p>
      )}
    </div>
  );
};

export default Accordion;
